/** Shared partner-session cookie: set at partner sign-in, read by LoginRoute to
 *  allow the silent Help Portal handoff, cleared by either app's logout. Scoped
 *  to the registrable parent (e.g. `.moutfitters.com`) so the Help Portal — a
 *  sibling subdomain — sees the same cookie. Name must match the portal's
 *  (stacks/tickets/web/src/intercom.ts). */
const PARTNER_SESSION_COOKIE = 'mo_partner_session';
const PARTNER_SESSION_MAX_AGE_SECONDS = 7 * 24 * 60 * 60;

const sharedDomain = (): string => {
    const labels = window.location.hostname.split('.');
    return labels.length >= 2 ? `.${labels.slice(-2).join('.')}` : '';
};

const cookieAttributes = (): string => {
    const secure = window.location.protocol === 'https:' ? '; secure' : '';
    return `path=/; samesite=lax${secure}`;
};

export const hasPartnerSession = (): boolean =>
    document.cookie.split(';').some((cookie) => cookie.trim().startsWith(`${PARTNER_SESSION_COOKIE}=`));

export const setPartnerSession = (): void => {
    const cookie = `${PARTNER_SESSION_COOKIE}=1; max-age=${PARTNER_SESSION_MAX_AGE_SECONDS}; ${cookieAttributes()}`;
    const domain = sharedDomain();
    if (domain) document.cookie = `${cookie}; domain=${domain}`;
    // localhost rejects the domain-scoped write — fall back to host-only.
    if (!hasPartnerSession()) document.cookie = cookie;
};

export const clearPartnerSession = (): void => {
    const expired = `${PARTNER_SESSION_COOKIE}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; ${cookieAttributes()}`;
    const domain = sharedDomain();
    document.cookie = expired;
    if (domain) document.cookie = `${expired}; domain=${domain}`;
};
